import React, { Component } from 'react'
import styled from 'styled-components'
import {
    LogoContainer,
    MainNavigation,
    media,
    NavContainer,
    SiteHeader
} from 'app/assets/styles'
import { Arrow, Close } from 'app/assets/icons'
import { Link } from 'app/common/link'
import { eventsDefinitions } from 'shared/store/metadata'
import type { ClickAndCollectPromotion, RestaurantShortDTO } from 'shared/types'
import { H5, H6 } from 'app/common/typography'
import { colors } from 'app-v2/design-systems/theme/colors'
import { HeaderModalAlert } from './HeaderModalAlertContainer'
import type { IntlShape } from 'react-intl'
import { injectIntl } from 'react-intl'
import { isKingdomPointsCoupon } from 'shared/utils/ecommerce/utils'
import { Icon } from 'app-v2/shared/features/icon'
import { tokens } from 'app-v2/shared/features/icon/utils/tokens'
import { orderPickUpType } from 'shared/utils'
import {
    formatTableToDisplay,
    getTableOrderValuesFromPickUpInfo
} from 'shared/utils-v2'
import { marketSelect } from '../../../../common/utils'
import logoReunion from 'shared/assets/images/logo-reunion.png'

type Props = {
    intl: IntlShape,
    restaurant?: RestaurantShortDTO,
    totalPrice?: number,
    cart?: boolean,
    currentStep?: number,
    collectModeText?: string,
    navigate: (to: string) => void,
    goBack: () => void,
    onCloseUrl?: string,
    showLogoBK?: boolean,
    backUrl?: string,
    backEnabled?: boolean,
    closeEnabled?: boolean,
    onClose?: () => void,
    history: Object,
    noDelivery?: boolean,
    promotion?: ClickAndCollectPromotion,
    untransformPoints: (couponCode: string) => void,
    collectMode?: string,
    pickUpInfo?: string
}

type State = {
    width: number
}

const cartBackUrl = (currentStep: number) => {
    switch (currentStep) {
        case 1:
            return 'routes.clickandcollect.delivery.choice'
        case 2:
            return 'routes.clickandcollect.catalog'
        case 3:
            return 'routes.clickandcollect.cart.summary'
        case 4:
            return 'routes.clickandcollect.cart.user.infos'
        default:
            return undefined
    }
}

class Header extends Component<Props, State> {
    render() {
        const {
            restaurant,
            cart,
            currentStep,
            navigate,
            intl,
            collectModeText,
            showLogoBK,
            backUrl,
            backEnabled,
            goBack,
            closeEnabled,
            onClose,
            noDelivery,
            promotion,
            untransformPoints,
            collectMode,
            pickUpInfo
        } = this.props

        const renderCatalogHeaderTitle = () => {
            const showSubtitle = !!collectModeText && !noDelivery
            const Title = showSubtitle ? H6 : H5
            return (
                <CenterItems>
                    <NavItem>
                        <Title>{restaurant && restaurant.name}</Title>
                    </NavItem>
                    {showSubtitle && (
                        <NavItem>
                            <Title>
                                {collectMode === orderPickUpType.TABLE_ORDER
                                    ? intl.formatMessage(
                                          { id: collectModeText },
                                          {
                                              table:
                                                  !!pickUpInfo &&
                                                  formatTableToDisplay(
                                                      getTableOrderValuesFromPickUpInfo(
                                                          pickUpInfo
                                                      ).table
                                                  )
                                          }
                                      )
                                    : intl.formatMessage({
                                          id: collectModeText
                                      })}
                            </Title>
                        </NavItem>
                    )}
                </CenterItems>
            )
        }

        const renderCartback = () => {
            return (
                currentStep && (
                    <ButtonNavItem
                        onClick={() => {
                            navigate(
                                intl.formatMessage({
                                    id: cartBackUrl(currentStep)
                                })
                            )
                        }}>
                        <Arrow color={colors.bbqBrown} />
                    </ButtonNavItem>
                )
            )
        }

        const renderGoBack = () => (
            <ButtonNavItem
                onClick={() => {
                    untransformPointsIfNeeded()
                    backUrl ? navigate(backUrl) : goBack()
                }}>
                <Arrow color={colors.bbqBrown} />
            </ButtonNavItem>
        )

        const renderClose = () => {
            return (
                <CloseIconContainer
                    onClick={() => {
                        untransformPointsIfNeeded()
                        if (closeEnabled) {
                            if (onClose) {
                                onClose()
                            } else {
                                navigate('/')
                            }
                        } else {
                            goBack()
                        }
                    }}>
                    <Close size={24} color={colors.bbqBrown} />
                </CloseIconContainer>
            )
        }

        const untransformPointsIfNeeded = () => {
            if (
                promotion &&
                promotion.couponCode &&
                isKingdomPointsCoupon(promotion.couponCode)
            ) {
                untransformPoints(promotion.couponCode)
            }
        }

        return (
            <StyledSiteHeader
                shouldStick
                background="plain"
                color="black"
                border>
                <MainNavigation>
                    <StyledResponsiveContainer>
                        {cart ? (
                            <NavContainer>
                                <NavItems>
                                    {currentStep && cartBackUrl(currentStep) ? (
                                        renderCartback()
                                    ) : (
                                        <FakeElement />
                                    )}
                                </NavItems>
                                <Container>
                                    {renderCatalogHeaderTitle()}
                                </Container>
                                <NavItems>
                                    <ButtonNavItem>
                                        <HeaderModalAlert />
                                    </ButtonNavItem>
                                </NavItems>
                            </NavContainer>
                        ) : (
                            <NavContainer>
                                <NavItems>
                                    {backEnabled && renderGoBack()}
                                </NavItems>
                                {showLogoBK ? (
                                    <LogoContainer>
                                        <Link
                                            url="/"
                                            meta={eventsDefinitions.LOGO}>
                                            {marketSelect({
                                                reunion: (
                                                    <LogoBKImg
                                                        src={logoReunion}
                                                    />
                                                ),
                                                france: (
                                                    <LogoBK
                                                        code={tokens.logo}
                                                        background={
                                                            colors.mayoEggWhite
                                                        }
                                                    />
                                                )
                                            })}
                                        </Link>
                                    </LogoContainer>
                                ) : (
                                    <NavItems>
                                        {renderCatalogHeaderTitle()}
                                    </NavItems>
                                )}
                                <NavItems>
                                    <ButtonNavItem>
                                        {renderClose()}
                                    </ButtonNavItem>
                                </NavItems>
                            </NavContainer>
                        )}
                    </StyledResponsiveContainer>
                </MainNavigation>
            </StyledSiteHeader>
        )
    }
}

const StyledResponsiveContainer = styled.div`
    width: calc(100% - 10px);
    padding-left: 5px;
    ${media.xsmall`
        width: calc(100% - 20px);
        padding-left: 10px;
    `}
    ${media.small`
        width: calc(100% - 40px);
    `}
    ${media.large`
        margin: 0 auto;
        width: 1280px;
    `};
`

const StyledSiteHeader = styled(SiteHeader)`
    border-bottom: ${props => props.border && `solid 1px ${colors.lightGrey}`};
`

const LogoBK = styled(Icon)`
    width: 50px;
    height: 50px;
    ${media.medium`
        width: 80px;
        height: 80px;
    `};
`

const LogoBKImg = styled.img`
    width: 50px;
    height: 50px;

    ${media.medium`
        width: 80px;
        height: 80px;
    `};
`

const FakeElement = styled.div`
    width: 30px;
    height: 30px;
`

const NavItems = styled.ul`
    margin: 0;
    display: flex;
    align-items: center;
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 5px 0;
`

const NavItem = styled.li`
    display: flex;
    justify-content: center;
    margin: 0 5px;
`

const CenterItems = styled.div`
    align-items: center;
    justify-content: center;
    margin: 0 5px;
`

const ButtonNavItem = styled(NavItem)`
    cursor: pointer;
    margin: 0 3px;
`

const CloseIconContainer = styled.div`
    padding: 10px;
`

export const HeaderComponent = injectIntl(Header)
